import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Contact from "../Elements/Desktop/Contact";
import MobileRecent from "../Elements/Mobile/MobileRecent";
import ProjectMenu from "../Elements/Desktop/ProjectMenu";
import MobileMenu from "../Elements/Mobile/MobileMenu";
import MobileHome from "../Elements/Mobile/MobileHome";
import MobileProject from "../Elements/Mobile/MobileProject";
import { Projects } from "../../ProjectData";

const Mobile = ({
  currentIndex,
  nextImage,
  prevImage,
  changeProject,
  setCurrentIndex,
  setCurrentProject,
}) => {
  const location = useLocation();
  const isProjectOrResume =
    location.pathname.startsWith("/recent/") || location.pathname === "/resume";

  if (isProjectOrResume) {
    return (
      <div className="main">
        <MobileMenu changeProject={changeProject} />

        <Routes>
          {Projects.map((project, index) => {
            const nextProject = Projects[(index + 1) % Projects.length];
            const prevProject =
              Projects[(index - 1 + Projects.length) % Projects.length];

            return (
              <Route
                key={project.route}
                path={`/recent/${project.route}`}
                element={
                  <MobileProject
                    projectKey={project.key}
                    setCurrentProject={setCurrentProject}
                    title={project.title}
                    role={project.role}
                    billing={project.billing}
                    imageSrc={project.images?.[currentIndex]}
                    nextImage={nextImage}
                    prevImage={prevImage}
                    nextProject={nextProject}
                    prevProject={prevProject}
                    changeProject={changeProject}
                    setCurrentIndex={setCurrentIndex}
                  />
                }
              />
            );
          })}

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    );
  }

  // One-page layout
  return (
    <div className="main scroll-wrapper">
      <MobileMenu changeProject={changeProject} />

      <div className="scroll-content">
        <ProjectMenu nextImage={nextImage} prevImage={prevImage} />

        <div className="page-section">
          <MobileHome />
        </div>
        <div className="page-section">
          <MobileRecent changeProject={changeProject} />
        </div>
        <Contact />
        <br/>
      </div>
    </div>
  );
};

export default Mobile;
